{
  "pt": {
    "contact": {
      "actions": {
        "accept": "Ok",
        "add": "Adicionar contacto",
        "add_type": "Adicionar {type}",
        "backInspirationLists": "Voltar às listas de inspiração",
        "cancelNew": "Anular",
        "deactivateEmployee": "Desativar",
        "deleteCustomer": "Eliminar cliente...",
        "deleteEmployee": "Eliminar membro da equipa...",
        "deleteLead": "Eliminar o chumbo...",
        "deletePartner": "Eliminar parceiro...",
        "delete_contact": "Eliminar",
        "edit": "Editar",
        "impersonate": "Fazer-se passar por",
        "impersonateStart": "Passe pelo portal laranja para explorar o mundo de {name}.",
        "impersonateStop": "Impedir a falsificação de identidade",
        "invite": "Enviar convite",
        "newTicket": "Nova conversa",
        "reactivateEmployee": "Reativar",
        "resendInvitationEmail": "Reenviar o convite por correio eletrónico",
        "searchContact": "Procurar contacto",
        "searchCustomer": "Pesquisar cliente",
        "searchEmployee": "Membro da equipa de pesquisa",
        "selectAll": "Selecionar todos os contactos de {total} ",
        "selectOption": "Selecionar opção",
        "setProfilePicture": "Definir imagem de perfil",
        "showall": "Mostrar tudo",
        "unSelectAll": "Limpar seleção."
      },
      "attributes": {
        "language": "Língua",
        "timezone": "Fuso horário",
        "title": "Título"
      },
      "labels": {
        "address": "Endereço",
        "all": "Todos os contactos",
        "back_to_overview": "Voltar à visão geral",
        "cannot_create_role": "Contacte um proprietário para criar um novo contacto",
        "cannot_delete": "Não é possível eliminar este utilizador (integração)",
        "company": "Empresa",
        "company_all": "Todas as empresas",
        "contact_status": {
          "active": "Ativo",
          "added": "Ainda não foi convidado",
          "all": "Todos os estatutos",
          "blocked": "Desativado",
          "invited": "Convidado",
          "status": "Estado"
        },
        "contact_type": "Tipo",
        "customer": "Cliente",
        "customers": "Clientes",
        "employee": "Equipa",
        "export_contacts": "Exportar contactos",
        "general": "Geral",
        "impersonateInactiveProfile": "Esta pessoa fantástica ainda não está ativa. Por favor, active o cliente primeiro.",
        "invite": "Sim, convidar contactos",
        "inviteProfileFirstCustomer": "Convidar primeiro o cliente para a plataforma para poder enviar mensagens, fazer-se passar por outra pessoa ou reenviar o convite por correio eletrónico",
        "inviteProfileFirstPartner": "Convidar o parceiro para a plataforma primeiro para se fazer passar por ele ou reenviar o e-mail de convite",
        "last_login": "Último login",
        "last_seen": "visto pela última vez",
        "last_seen_not_seen_yet": "ainda não iniciou sessão",
        "lead": "Chumbo",
        "name": "Nome",
        "name_or_email_address": "Nome ou endereço eletrónico",
        "name_or_email_address_phone": "Nome, endereço eletrónico ou telefone",
        "noContacts": "Sem contactos",
        "no_contacts": "Não há contactos para exportar",
        "no_contacts_results": "Esta pesquisa não tem resultados. Experimente outros filtros para encontrar a pessoa certa.",
        "no_contacts_results_subtitle": "Esta busca não retornou resultados. Experimente outros filtros para encontrar a pessoa certa.",
        "no_contacts_results_title": "Nenhum contato encontrado",
        "number_contacts": "Sem contactos | 1 contacto | {count} contactos",
        "other": "Outros",
        "partner": "Parceiro",
        "partners": "Parceiros",
        "project": "Projeto",
        "secondary_contact": "Contacto secundário",
        "selectOne": "Selecionar pelo menos 1 contacto",
        "selectProjectForImpersonation": "Para que projeto pretende fazer-se passar por {customer_name}?",
        "selected": "{selected} contacto selecionado. | {selected} contactos seleccionados.",
        "sorting": {
          "last_name": "Nome",
          "session_started_at": "Último login",
          "status": "Estado"
        },
        "totalSelected": "Todos os contactos {total} são seleccionados.",
        "units": "Unidades"
      },
      "navigation": {
        "backToContacts": "Voltar aos contactos"
      },
      "placeholders": {
        "byNameOrEmailAddress": "Por nome ou endereço eletrónico"
      },
      "validation": {
        "emailTaken": "O endereço de correio eletrónico é o mesmo que o anterior",
        "mustBeEmailAddress": "É necessário um endereço de correio eletrónico válido",
        "requireEmailAddress": "Correio eletrónico necessário"
      }
    }
  }
}
